import React, {Component} from 'react';
import {Breadcrumb, Label} from 'semantic-ui-react';
import {Link} from 'react-router-dom';
import {Helmet} from "react-helmet";


import CustomDivider from '../../components/extras/CustomDivider';
import ProductDialog from "../../components/inventories/ProductDialog";
import DynamicTable from "../../components/extras/DynamicTable";
const c = require("../../constants");

class TrackType extends Component{
    render(){
        return <span>
            {c.WAREHOUSE_STOCK_MOVEMENTS.find((data) => data.key===this.props.track_type).text}
        </span>
    }
}

class WarehouseStock extends Component{
    render(){
        return <span>
            {this.props.warehouse_stock.item}
            <br/>
            <Label size='tiny'>
              {c.WAREHOUSE_STOCK_TYPES.find((data) => data.key===this.props.warehouse_stock.stock_type).text}
            </Label>
        </span>
    }
}


class QuantityStock extends Component{
    render(){
        return <span>
            {Math.abs(this.props.quantity)}
        </span>
    }
}

class StockMovementsWarehouse extends Component {

    constructor() {
        super();
        this.state = {
            table: {
                headers: ['Fecha y Hora', 'Usuario', 'Elemento', 'Tipo de Movimiento', 'Cantidad', 'Observaciones'],
                title: 'Movimientos - Bodega',
                name: 'Producto',
                has_actions: false,
                pagination: true,
                url: `warehouse-stock-control`,
                values: ['id', 'date', 'user', 'warehouse_stock', 'track_type', 'quantity', 'observations'],
                datetime_fields: ['date'],
                child_fields: [{user:'full_name'}],
                component_fields:[{
                    track_type: TrackType,
                    warehouse_stock: WarehouseStock,
                    quantity: QuantityStock
                }],
                id: 'table_stock'
            },
        };
    }

    render() {

        return (
            <div>
                <Helmet>
                    <title>Bodega | Movimientos de Inventario - Quipuu</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/inventories'>Inventarios</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section active>Movimientos de Inventario - Bodega</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                <DynamicTable {...this.state.table} callbackDynamicTable={this.callbackDynamicTable}/>
                <ProductDialog/>
            </div>
        );
    }
}

export default StockMovementsWarehouse;



// WEBPACK FOOTER //
// ./src/containers/inventories/StockMovementsWarehouse.js